import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import 'rxjs/add/operator/take';
import {SurveyFilterUIModel, SurveyQuestionFilterRawModel} from '../../../models/survey/survey.model';

@Component({
  selector: 'cut-create-popup',
  templateUrl: './cut-create-popup.component.html',
  styleUrls: ['./cut-create-popup.component.less']
})
export class CutCreatePopupComponent implements OnInit {
  title: string;
  isValid = false;
  @Output('close') close = new EventEmitter();
  @Output('save') save = new EventEmitter();
  @Input() listSurveyQuestionRawFilter: SurveyQuestionFilterRawModel[] = [];
  @Input() listSurveyFilterUI: SurveyFilterUIModel[] = [];
  @Input() listSurveyVersionUI: any[] = [];
  @Input() isPreviewSegment: boolean = false;

  constructor() {

  }

  ngOnInit() {
  }

  onClose() {
    this.close.next();
  }

  onSave() {
    this.save.next(this.title);
  }

  getQuestionName(q) {
    return this.listSurveyQuestionRawFilter.find(x => x.id === q.question.id).question;
  }

  getListAnswer(q): string[] {
    return this.listSurveyQuestionRawFilter
      .find(x => x.id === q.question.id).listSurveyAnswerFilter
      .filter(x => q.listAnswerId.includes(x.id))
      .map(x => x.answer);
  }

  onTitleChange(event) {
    this.isValid = event && event.trim() !== '';
  }

  isChoiceQuestion(q) {
    const listChoiceQuestionType: string[] = [
      'SingleChoice', 'MultipleChoice', 'Dropwdown', 'PictureChoice', 'YesNo'
    ];

    return listChoiceQuestionType.includes(q.question.answerType);
  }

  isNotShowOperator(q) {
    const listChoiceQuestionType: string[] = [
      'Dropwdown', 'PictureChoice', 'YesNo'
    ];

    return listChoiceQuestionType.includes(q.question.answerType);
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/cut/cut-create-popup.component.ts